import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
} from "recharts";
import { fetchEmployeeSummary } from "../services/dashboardService";

const SalaryReportChart: React.FC<{
  month: number | "";
  year: number | "";
}> = ({ month, year }) => {
  const [chartData, setChartData] = useState<
    { name: string; salary: number }[]
  >([]);

  useEffect(() => {
    const loadChartData = async () => {
      try {
        if (typeof month === "number" && typeof year === "number") {
          const response = await fetchEmployeeSummary(month, year);
          const rawData = response.data;

          const transformed = rawData.map((item: any) => ({
            name: item.customer ?? "Unknown",
            salary: item.totalSalary ?? 0,
          }));
          console.log("parthi2" + JSON.stringify(transformed));
          setChartData(transformed);
        }
      } catch (error) {
        console.error("Failed to load employee summary:", error);
      }
    };
    loadChartData();
  }, [month, year]);

  return (
    <div className="p-4 border-2 border-blue-400 rounded-lg shadow-sm">
      <Typography variant="subtitle1" mb={3} fontWeight={500}>
        Salary Report
      </Typography>

      <ResponsiveContainer width="100%" height={270}>
        <LineChart
          data={chartData}
          margin={{ top: 15, right: 15, bottom: 15, left: 15 }}
        >
          <defs>
            <linearGradient id="colorSalary" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.4} />
              <stop offset="95%" stopColor="#4f46e5" stopOpacity={0} />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="name" tick={{ fontSize: 12 }} />
          <YAxis
            tickFormatter={(value) => value.toLocaleString("en-IN")}
            tick={{ fontSize: 12 }}
            width={50}
          />
          <Tooltip
            formatter={(value: number) =>
              `₹${value.toLocaleString("en-IN")}`
            }
          />
          <Line
            type="monotone"
            dataKey="salary"
            stroke="#4f46e5"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
          <Area
            type="monotone"
            dataKey="salary"
            stroke="none"
            fill="url(#colorSalary)"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalaryReportChart;
